<div class="search">
  <input type="text" [placeholder]="placeholder" (keyup)="keyUp($event)" >
  <i class="fas fa-search"></i>
</div>